import React from 'react';
const getTotalPages = ({ perPage, total }) => Math.ceil(total / perPage);
const checkPageValidity = (totalPages, { total, currentPage, goToPage }) => {
    // Go to the last available page if the selected page does not exist
    if (total > 0 && totalPages < currentPage)
        goToPage(totalPages);
    if (total === 0)
        goToPage && goToPage(1);
};
const incrementPage = (page) => {
    return page + 1;
};
const decrementPage = (page) => {
    return page - 1;
};
export default class PaginationBehaviour extends React.Component {
    constructor(props) {
        super(props);
        this.setTotalPages = () => {
            const totalPages = getTotalPages(this.props);
            this.setState({ totalPages });
            return totalPages;
        };
        this.nextPage = () => {
            const { currentPage } = this.props;
            const { totalPages } = this.state;
            currentPage < totalPages && this.props.goToPage(incrementPage(currentPage));
        };
        this.prevPage = () => {
            const { currentPage } = this.props;
            currentPage !== 1 && this.props.goToPage(decrementPage(currentPage));
        };
        this.getStateAndProps = () => {
            return {
                totalItems: this.props.total,
                totalPages: this.state.totalPages,
                currentPage: this.props.currentPage,
                prevPage: this.prevPage,
                nextPage: this.nextPage,
                goToPage: this.props.goToPage,
                setProductsPerPage: this.props.setProductsPerPage,
                isFirstPage: this.props.currentPage === 1,
                isLastPage: this.props.currentPage === this.state.totalPages,
                hasPages: this.state.totalPages !== 0
            };
        };
        this.state = {
            totalPages: getTotalPages(props)
        };
    }
    componentDidMount() {
        const totalPages = this.setTotalPages();
        checkPageValidity(totalPages, this.props);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.total !== this.props.total) {
            const totalPages = this.setTotalPages();
            checkPageValidity(totalPages, this.props);
        }
        if (prevProps.perPage !== this.props.perPage) {
            this.setTotalPages();
        }
    }
    render() {
        return this.props.children(this.getStateAndProps());
    }
}
//# sourceMappingURL=PaginationBehaviour.js.map